export const getItems = (state) => () => {
    return state.items
}

export const sumItems = (state) => () => {
    return state.items
}

